import { createFileRoute } from "@tanstack/react-router"
import { FrontAppIntegration } from "modules/settings/components/integrations/frontapp"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/frontapp")({
  component: FrontAppIntegration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.frontapp.title"),
    })
  },
})
